import { extendTheme } from '@chakra-ui/react';
import { global } from './globals';
import { colors } from './colors';
import { Input, Switch, Popover, Select, Tabs } from './components';

export const theme = extendTheme({
  colors,
  styles: {
    global,
  },
  components: {
    Input,
    Switch,
    Popover,
    Select,
    Tabs,
  },
});

export const scTheme = {
  colors: colors.brand,
  button: {
    primary: {
      background: colors.brand.primary,
      color: colors.brand.white,
      // shadow: '0px 3px 6px #00000029',
      shadow: 'none',
      outline: {
        color: colors.brand.primary,
        border: colors.brand.primary,
      },
    },
    cancel: {
      background: colors.brand[1300],
      color: colors.brand[600],
      shadow: 'none',
      outline: {
        color: colors.brand[600],
        border: colors.brand[600],
      },
    },
    danger: {
      background: colors.brand.red100,
      color: colors.brand[1300],
      shadow: 'none',
      outline: {
        color: colors.brand.red100,
        border: colors.brand.red100,
      },
    },
    secondary: {
      background: colors.brand[900],
      color: colors.brand[1300],
      shadow: 'none',
      outline: {
        color: colors.brand[900],
        border: colors.brand[900],
      },
    },
    gray: {
      background: colors.brand.gray600,
      color: colors.brand[1300],
      shadow: 'none',
      outline: {
        color: colors.brand.gray600,
        border: colors.brand.gray600,
      },
    },
    accept: {
      background: colors.brand.green500,
      color: colors.brand[1300],
      shadow: 'none',
      outline: {
        color: colors.brand.gray600,
        border: colors.brand.gray600,
      },
    },
  },
  statusTag: {
    accept: {
      background: colors.brand.green500,
      color: colors.brand.white,
    },
    danger: {
      background: colors.brand.red200,
      color: colors.brand.white,
    },
    warn: {
      background: colors.brand.tangerine,
      color: colors.brand.white,
    },
    info: {
      background: colors.brand.blue500,
      color: colors.brand.white,
    },
    notDefined: {
      background: colors.brand.purple,
      color: colors.brand.white,
    },
    moderate: {
      background: colors.brand.tangerine500,
      color: colors.brand.white,
    },
    transparent: {
      background: 'transparent',
      color: colors.brand[1400],
    },
  },
  statusTagBugetControl: {
    accept: {
      background: colors.brand.green500,
      color: colors.brand.white,
    },
    danger: {
      background: colors.brand.red200,
      color: colors.brand.white,
    },
    warn: {
      background: colors.brand.tangerine,
      color: colors.brand.white,
    },
    info: {
      background: colors.brand.blue500,
      color: colors.brand.white,
    },
    notDefined: {
      background: colors.brand.purple,
      color: colors.brand.white,
    },
    moderate: {
      background: colors.brand.tangerine500,
      color: colors.brand.white,
    },
    transparent: {
      background: 'transparent',
      color: colors.brand[1400],
    },
  },
};
